import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Col, Row } from 'react-bootstrap'
import { windowResize } from '../utils';
import { getEvents } from "../actions/eventsAction";
import { $t } from '../utils/translate';
import { getMessages } from '../actions/messageActions';

import { getDraws } from "../actions/eventsAction";
import BetBar from '../components/BetBar';
class HowtoplayPage extends Component {

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      windowResize();
    }
  }

  componentDidMount() {
    if (this.props.gamesList == '') {
      this.props.getEvents();
      this.props.getDraws();
    }
    document.title = "How to play";
    windowResize();
  }

  render() {

    const jackpots = []
    let gameslistKeys = Object.keys(this.props.gamesList);
    for (let j = 0; j < gameslistKeys.length; j++) {
      jackpots.push({
        name: gameslistKeys[j], link: gameslistKeys[j].toLowerCase()
      })
    }
    if(jackpots.length==0){
      jackpots.push({
        name: "Multi-Market", link: "multi-market"
      })
    }
    return (
      <div className="how-to-play">

        <BetBar jackpot={jackpots[0]} />
        {/* } */}
        <div className="content p-3">
          <p><strong>{$t('header_how_to_play', 'default', this.props.messages)}</strong></p>
          <p className="text-justify">
          Place one cash bet of any amount or odds on your preferred sports fixture (live or pre-match) to gain one free entry into our Daily Jackpot. Then, use your entry to correctly predict the outcome of selected Bet Types in the fixtures provided and you could win your share of R10,000 every day. Terms and conditions apply.
            {/* {$t('body_text_how_to_play', 'default', this.props.messages)} */}
          </p>
          <p>Follow these guides to get started:</p>

          <Row noGutters>
            <Col md={12} lg={4} className="p-2">
              <Card>
                <Card.Body className="p-2">
                  <Row>
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number1.svg" alt="1" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p className="pt-2">Log into your <strong>Betway Account</strong></p>
                      <div className="illustration pt-1">
                        <img src="/assets/icons/icon_login.svg" alt="Login" />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card className="bg-grey m-0">
                <Card.Body className="p-2">
                  <Row className="pb-2">
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number2.svg" alt="2" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p>From the homepage, choose the <strong>sport</strong> you'd like to bet on.</p>
                    </Col>
                  </Row>
                  <Row noGutters className="pb-2">
                    <Col xs={12} className="pr-2">
                      <img src="/assets/icons/icon_games.svg" alt="Games" />
                    </Col>
                    {/* <Col xs={3}>
                      <img src="/assets/icons/icon_jikasports.svg" alt="Jikasports" />
                    </Col> */}
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card>
                <Card.Body className="p-2">
                  <Row className="pb-2">
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number3.svg" alt="3" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p className="pt-0 pr-2">Find the <strong>match</strong> or <strong>matches</strong> you'd like to bet on</p>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col xs={12}>
                      <img src="/assets/icons/icon_matches.svg" alt="Matches" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card className="bg-grey m-0">
                <Card.Body className="p-2">
                  <Row className="pb-2">
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number4.svg" alt="4" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p className="pt-2">Choose your <strong>outcome</strong></p>
                    </Col>
                  </Row>
                  <Row noGutters className="pt-2 pb-3">
                    <Col xs={12}>
                      <img src="/assets/icons/icon_chooseoutcome.svg" alt="Outcome" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card>
                <Card.Body className="p-2">
                  <Row>
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number5.svg" alt="5" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p className="pt-0">Complete your betslip and click on <strong>Bet Now</strong></p>
                      <div className="illustration px-3 pt-1 pb-2">
                        <img src="/assets/icons/icon_betslip.svg" alt="Betslip" />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card className="bg-grey m-0">
                <Card.Body className="p-2">
                  <Row className="pb-2">
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number6.svg" alt="6" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p>Once your bet has been placed, you'll receive one <strong>free Jackpot entry</strong></p>
                    </Col>
                  </Row>
                  <Row noGutters>
                    <Col xs={9} className="pr-2">
                      <img src="/assets/icons/icon_DailyJackpotLogo.svg" alt="Games" />
                    </Col>
                    <Col xs={3}>
                      <img src="/assets/icons/icon_entry.svg" alt="Entry" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

          </Row>

          <p className="mt-3">To use your free Jackpot entry, return to the Daily Jackpot page and follow the steps below:</p>

          <Row noGutters>
            <Col md={12} lg={4} className="p-2">
              <Card>
                <Card.Body className="p-2">
                  <Row>
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number1.svg" alt="1" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p>Visit the <strong>Daily Jackpot</strong> homepage</p>
                      <div className="illustration pt-4">
                        <a href="https://www.betway.co.za/jackpot"><img src="/assets/icons/icon_url_2.1.svg" alt="Daily Jackpot" /></a>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card className="bg-grey mt-0">
                <Card.Body className="p-2">
                  <Row>
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number2.svg" alt="2" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p><strong>Choose one outcome</strong> from each fixture</p>
                      <div className="illustration pt-1 pr-4">
                        <img src="/assets/icons/icon_choose1outcome.svg" alt="Outcome" />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={4} className="p-2">
              <Card className="bg-dark">
                <Card.Body className="p-2">
                  <Row>
                    <Col xs={2}>
                      <img className="pr-2 pr-md-0" src="/assets/icons/icon_number3.svg" alt="3" width="45"/>
                    </Col>
                    <Col xs={10} className="l-45">
                      <p className="text-light">Once you're happy with your selections, click on <strong>Submit</strong></p>
                      <div className="illustration pt-1 px-2">
                        <img src="/assets/icons/icon_submit_bttn_2.svg" alt="Login" />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

          </Row>

          <p className="mt-3">
          Unlimited entries based on tickets available 
            {/* Please note that you will only be able to enter the jackpot once every 24 hours and that a
            new bet must be placed each day in order to earn another ticket.
            Jackpots may not result on the same day and will only result after
            the last fixture in the selection has been completed. */}
          </p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.messageReducer.messages,
    gamesList: state.eventsReducer.gamesList
  }
}

export default connect(mapStateToProps,{getMessages,getDraws,getEvents})(HowtoplayPage);




// WEBPACK FOOTER //
// ./pages/howtoplayPage.js